//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { checkDependency } from '@/datalayer/helpers/attributes';

const findCurrentOption = (attributes, slug, value) => {
  const attrib = attributes.find((a) => a.slug === slug);

  if (attrib) {
    const option = attrib.type_options.options.find((o) => o.value === value);

    return option;
  }

  return null;
};

export default {
  props: {
    isSearching: {
      type: Boolean,
      default: false,
    },
    group: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    category: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    subcategory: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    values: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  computed: {
    backTitle() {
      if (this.currentCategory) {
        return `Back to all ${this.currentGroup.name}`;
      }

      if (this.isSearching && this.currentGroup) {
        return 'Back to all results';
      }

      if (this.currentGroup) {
        return `Back to all ${this.currentGroup.name}`;
      }

      return 'Back';
    },
    shopBy() {
      return this.currentGroup ? 'Shop by category:' : 'Shop by:';
    },
    name() {
      return this.currentCategory?.name || 'Category';
    },
    currentGroup() {
      const { group } = this.values;
      return findCurrentOption(this.$store.state.browse.attributes, 'group', group);
    },
    currentCategory() {
      const { category } = this.values;
      return findCurrentOption(this.$store.state.browse.attributes, 'category', category);
    },
    currentSubcategory() {
      const { subcategory } = this.values;
      return findCurrentOption(this.$store.state.browse.attributes, 'subcategory', subcategory);
    },
    groups() {
      let options = [...(this.group?.type_options?.options || [])];

      options = options.filter((o) => checkDependency(o.dependency, this.values));
      return options;
    },
    categories() {
      let options = [...(this.category?.type_options?.options || [])];

      options = options.filter((o) => checkDependency(o.dependency, this.values));
      return options;
    },
    subcategories() {
      let options = [...(this.subcategory?.type_options?.options || [])];

      options = options.filter((o) => checkDependency(o.dependency, this.values));
      return options;
    },
  },
  methods: {
    select(event, value) {
      if (event === 'category') {
        const isMobile = (window.innerWidth < 768);

        if (this.currentCategory && this.currentCategory.value === value) {
          this.$emit(isMobile ? event : 'subcategory', null);
        } else {
          this.$emit(event, value);
        }
      } else {
        this.$emit(event, value);
      }
    },
    back() {
      if (this.currentCategory) {
        return this.$emit('category', null);
      }

      return this.$emit('group', null);
    },
  },
};
